import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import ErrorBoundary from 'components/ErrorBoundary'
import ContractLineSearch from './search/ContractLineSearch'
import ContractLine from './ContractLine'

interface ContractLineRouterProps {
  // Add any additional props if needed
}

const ContractLineRouter: React.FC<ContractLineRouterProps> = () => {
  const match = useRouteMatch()

  return (
    <ErrorBoundary>
      <Switch>
        <Route component={ContractLine} path={`${match.path}/:id`} />
        <Route component={ContractLineSearch} path={match.path} />
      </Switch>
    </ErrorBoundary>
  )
}

export default ContractLineRouter
